import type { AccordionSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import type { ElementStyleCss } from 'services/Branding/types'

import { transformArrayToString } from './styled'

const ContentStyled = styled.section<{ $styles: ElementStyleCss<AccordionSchemaType> }>`
  background-color: ${({ $styles }) => $styles.collapse.backgroundColor};
  padding: ${({ $styles }) => transformArrayToString($styles.indents.content)};
  border-bottom-left-radius: ${({ $styles }) => $styles.border.borderRadius};
  border-bottom-right-radius: ${({ $styles }) => $styles.border.borderRadius};
`

export default ContentStyled
